import { render, staticRenderFns } from "./VxCellPromocodeBonusInfo.vue?vue&type=template&id=8c94e718&"
import script from "./VxCellPromocodeBonusInfo.vue?vue&type=script&lang=js&"
export * from "./VxCellPromocodeBonusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports